import React from "react";
import API from "@beardeddevops/react.api";
import Types from "../../constants/Types";
import moment from "moment";

export default function RemoteAppointments({date = moment().format('YYYY-MM-DD')}) {
	const [data, setData] = React.useState([]);
	const [nextDay, setNextDay] = React.useState([]);
	React.useEffect(() => {
		const dataModel = new API.BuildClass(Types.Tickets._name, API.RequestType.READ);
		dataModel.filter = {
			'date': date
		}
		dataModel.submit(null, 'GET_REMOTE_APPOINTMENTS', true).then((data) => {
			setData(data.items.remotes_today?.split('|||').map((region) => {
				return {Name: region.split('||')[0], Pkey: region.split('||')[1]}
			}) ?? [])
			setNextDay(data.items.remotes_tomorrow?.split('|||').map((region) => {
				return {Name: region.split('||')[0], Pkey: region.split('||')[1]}
			}) ?? [])
		})
	}, [date])

	function setLocalData(region, _date) {
		//set the region for the calendar
		window.localStorage.setItem('regions', JSON.stringify([region]))
		window.localStorage.setItem('date', _date)
	}

	return (
		<div className={'form-group'}>
			<div className={'row'}>
				<div className={'col-12'}>
					<h4 className="section-title">
						Remote Appointments For {moment(date).format('dddd MMM D')}
					</h4>
				</div>
			</div>
			<div className={'row'}>
				{data && data.map((item) => <div className={'col-auto'}>
					<b onMouseDown={() => setLocalData({'label': item.Name, 'value': item.Pkey}, moment(date).add(10, 'hours').format())}
					>
						<a href={'/dispatch/calendar'}>{item === 'N/A' ? 'N/A' : item.Name}</a>
					</b>
				</div>)}
			</div>
			<div className={'row'}>
				<div className={'col-12'}>
					<h4 className="section-title">
						Remote Appointments For {moment(date).add(1, 'day').format('dddd MMM D')}
					</h4>
				</div>
			</div>
			<div className={'row'} style={{marginTop: 15}}>
				{nextDay && nextDay.map((item) => <div className={'col-auto'}>
					<b onMouseDown={() => setLocalData({
						'label': item.Name,
						'value': item.Pkey
					}, moment(date).add(10, 'hours').add(1, 'day').format())}
					>
						<a href={'/dispatch/calendar'}>{item === 'N/A' ? 'N/A' : item.Name}</a>
					</b>
				</div>)}
			</div>
		</div>
	)
}